import apiClient from 'api/apiClient';

// eslint-disable-next-line import/prefer-default-export

// We should grab all of the product types from the API since there are few records
export const getProductTypes = () => apiClient.get('/v1/product_types');

export default getProductTypes;
